import { StyleSheet, ViewProps } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useProduct } from 'zens-store'
import { BreadcrumbData } from 'zens-storybook'
import { useBreadcrumb } from '@dms/hook'
import { ReactElement } from 'react'

import { LayoutHeader } from '../layout'
const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  productId: number
  title?: string
  accessory?: ReactElement
  breadcrumbItems?: BreadcrumbData[]
}

const ProductHeader = (props: Props) => {
  const { companyId, productId, title, accessory, breadcrumbItems, style, ...otherProps } = props
  const { t } = useTranslation()
  const product = useProduct({ companyId, productId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Devices'),
      href: `/companies/${companyId}/products`,
    },
    {
      title: product.data?.serialNumber || '',
      href: `/companies/${companyId}/products/${productId}`,
    },
    ...(breadcrumbItems || []),
  ])

  return (
    <LayoutHeader
      style={[styles.container, style]}
      breadcrumb={breadcrumb}
      title={`${product.data?.serialNumber}${title ? ` - ${title}` : ''}`}
      accessory={accessory}
      {...otherProps}
    />
  )
}

export default ProductHeader
